
import React, { useState, useEffect } from 'react';
import QrScan from "../components/QrScan";

const QrScanner: React.FC = () => {
  return (
    <div className="p-4">
      <h2 className="text-2xl font-semibold mb-4 text-center">QR Code Scanner</h2>
      <QrScan />
    </div>
  );
}  

export default QrScanner;
